import styles from "./styles.module.css";
import { SketchPicker } from "react-color";
import { useEffect, useState, useContext } from "react";
import { AppValue } from "../contexts/app";
import ClickAwayListener from "react-click-away-listener";
export default function Color({ value, onChange }) {
  const [color, setColor] = useState("grey");
  const [visible, setVisible] = useState(false);
  const { palette = [] } = useContext(AppValue);
  const handleChange = (color) => {
    const { r, g, b, a } = color.rgb;
    setColor(`rgba(${r},${g},${b},${a})`);
  };
  const handleClickAway = () => {
    setVisible(false);
    onChange(color);
  };
  useEffect(() => {
    setColor(value);
  }, [value]);
  return (
    <div style={{ position: "relative", width: "100%" }}>
      <div
        style={{
          backgroundColor: value,
          width: 40,
          height: 20,
          borderRadius: 5,
          border: "1px solid #E0E0E0",
          cursor: "pointer",
        }}
        onClick={() => setVisible(!visible)}
      ></div>
      {visible && (
        <ClickAwayListener onClickAway={handleClickAway}>
          <div style={{ position: "absolute", top: 28, zIndex: 4000 }}>
            <SketchPicker
              presetColors={palette}
              onChange={handleChange}
              color={color}
            />
          </div>
        </ClickAwayListener>
      )}
    </div>
  );
}
